export default __webpack_public_path__ + "static/media/txt_aeon_hall.a7eb8a8b.svg";